import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import SmartConDevHero from "./SmartConDevHero";
import OurSmartConDev from "./OurSmartConDev";
import WhyCSmartContract from "./WhyCSmartContract";

function SmartContractDev() {
  return (
    <div>
      <Header />
      <SmartConDevHero />
      <OurSmartConDev />
      <WhyCSmartContract />
      <Footer />
    </div>
  );
}

export default SmartContractDev;
